/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type ImageVersionTypeName = "large" | "master" | "medium" | "original" | "placeholder" | "small" | "thumb" | "zoom" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CartNav_item = {
    readonly pdpURL: string | null;
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly isSold: boolean | null;
    readonly photos: ReadonlyArray<{
        readonly versions: ReadonlyArray<{
            readonly webPath: string | null;
            readonly type: {
                readonly name: ImageVersionTypeName | null;
            } | null;
        } | null> | null;
    } | null> | null;
    readonly pricing: {
        readonly netPrice: {
            readonly amount: number | null;
            readonly currency: Currency | null;
            readonly convertedAmountList: ReadonlyArray<{
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null> | null;
        } | null;
        readonly salePrice: {
            readonly amount: number | null;
            readonly currency: Currency | null;
            readonly convertedAmountList: ReadonlyArray<{
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null> | null;
        } | null;
        readonly retailPrice: {
            readonly amount: number | null;
            readonly currency: Currency | null;
            readonly convertedAmountList: ReadonlyArray<{
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": "CartNav_item";
};
export type CartNav_item$data = CartNav_item;
export type CartNav_item$key = {
    readonly " $data"?: CartNav_item$data;
    readonly " $fragmentRefs": FragmentRefs<"CartNav_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "convertedAmountList",
    "storageKey": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v0/*: any*/)
    ]
  }
];
return {
  "kind": "Fragment",
  "name": "CartNav_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pdpURL",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isSold",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "photos",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "versions",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "webPath",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "type",
              "storageKey": null,
              "args": null,
              "concreteType": "ImageVersionType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPricing",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "netPrice",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v2/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "salePrice",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v2/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "retailPrice",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": (v2/*: any*/)
        }
      ]
    }
  ]
};
})();
(node as any).hash = '1db7dee65aa8a71129cd0829f10f7757';
export default node;
